module.exports = __webpack_public_path__ + "img/round-partner.ffa3fff.png";